module.exports = __webpack_public_path__ + "img/metacritic.fb96c428.png";